/*
  La Famille Tremblay - extra's voor het eigen winkelmandje (vervangt Upcart)
  - Kortingsbalk: 1 article 10 %, 2 = 15 %, 3 = 20 %, 4+ = 25 %
  - Regel "Rabais appliqué" boven het totaal
  - Upsells "Complétez votre look" met keuze van imprimé/taille
  Haakt in op CartDrawerController uit cart-drawer.js (moet daarna geladen worden).
*/
(function () {
  if (typeof CartDrawerController === 'undefined') return;

  var P = CartDrawerController.prototype;
  var TIERS = [
    { qty: 1, pct: 10 },
    { qty: 2, pct: 15 },
    { qty: 3, pct: 20 },
    { qty: 4, pct: 25 }
  ];
  var MAX_UPSELLS = 1;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; var LFT_TUQUE = 'niki-noor-silk-winter-hat-wool-silk-anti-frizz-hair-protection', LFT_MERINO = 'merino-wool-ribbed-knit-sweater-with-roll-neck-for-women', LFT_BOTTES = 'naisten-lumikengat-vedenpitavat-liukumattomat-lampimat-talvikengat'; var LFT_PAIRS = { shoes: [LFT_TUQUE, LFT_MERINO], outer: [LFT_TUQUE, LFT_MERINO], top: [LFT_TUQUE, LFT_BOTTES], other: [LFT_TUQUE, LFT_MERINO] }; async function lftPairs(base) { if (!base) return []; var t = ((base.product_title || base.title || '') + ' ' + (base.product_type || '')).toLowerCase(); var cat = /botte|bottillon|chaussure|mocassin|soulier|sandale|boot|shoe/.test(t) ? 'shoes' : /manteau|veste|parka|blouson|anorak|coat|jacket/.test(t) ? 'outer' : /chandail|cardigan|tricot|pull|tunique|cachemire|haut|blouse|chemise|sweater|hoodie|knit/.test(t) ? 'top' : 'other'; var out = []; for (var h of LFT_PAIRS[cat]) { if (h === base.handle) continue; try { var r = await fetch(ROOT + 'products/' + h + '.js', { headers: { Accept: 'application/json' } }); if (r.ok) out.push(await r.json()); } catch (e) { console.error(e); } } return out; }

  var origRender = P.render;
  P.render = function (cart) {
    this.lftLastRender = Date.now();
    origRender.call(this, cart);
    try {
      this.lftExtras(cart);
    } catch (error) {
      console.error(error);
    }
  };

  var origClick = P.handleDrawerClick;
  P.handleDrawerClick = async function (event) {
    var button = event.target.closest('[data-upsell-add]');
    if (button) {
      await this.lftAddUpsell(button);
      return;
    }
    return origClick.call(this, event);
  };

  var origChange = P.handleDrawerChange;
  P.handleDrawerChange = async function (event) {
    if (event.target.matches && event.target.matches('[data-upsell-variant]')) {
      event.target.classList.remove('is-invalid');
      return;
    }
    return origChange.call(this, event);
  };

  P.lftEnsureNodes = function () {
    if (this.lftNodes) return this.lftNodes;

    var tier = document.createElement('div');
    tier.className = 'cart-tier';
    tier.hidden = true;
    tier.setAttribute('aria-live', 'polite');
    var header = this.drawer.querySelector('.cart-drawer__header');
    if (header) header.appendChild(tier);

    var upsell = document.createElement('div');
    upsell.className = 'cart-upsell';
    upsell.hidden = true;

    var discount = document.createElement('div');
    discount.className = 'cart-drawer__summary-row cart-drawer__discount-row';
    discount.hidden = true;
    discount.innerHTML = '<span>Rabais appliqué</span><span data-lft-discount></span>';
    var summary = this.drawer.querySelector('.cart-drawer__summary');
    if (summary) summary.insertBefore(discount, summary.firstChild);

    this.lftNodes = { tier: tier, upsell: upsell, discount: discount };
    return this.lftNodes;
  };

  P.lftExtras = function (cart) {
    var nodes = this.lftEnsureNodes();
    this.lftRenderTier(nodes.tier, cart);
    this.lftRenderDiscount(nodes.discount, cart);
    // Upsells scrollen mee onder de producten, zodat de producten zelf genoeg ruimte houden
    if (this.body && (cart.item_count || 0) > 0) this.body.appendChild(nodes.upsell);
    this.lftRenderUpsells(nodes.upsell, cart);
  };

  P.lftRenderTier = function (node, cart) {
    var count = cart.item_count || 0;
    if (!count) {
      node.hidden = true;
      node.innerHTML = '';
      return;
    }

    var current = TIERS.filter(function (t) { return count >= t.qty; }).pop();
    var next = TIERS.find(function (t) { return count < t.qty; });
    var message;

    if (next) {
      var missing = next.qty - count;
      message =
        '<strong>' + current.pct + ' % de plus</strong> à la caisse. Ajoutez ' +
        missing + ' article' + (missing > 1 ? 's' : '') +
        ' pour obtenir <strong>' + next.pct + ' %</strong>!';
    } else {
      message = '🎉 <strong>Rabais maximal de 25 %</strong> débloqué, appliqué à la caisse!';
    }

    var fill = Math.min(count / TIERS[TIERS.length - 1].qty, 1) * 100;
    var steps = TIERS.map(function (t) {
      return (
        '<li class="cart-tier__step' + (count >= t.qty ? ' is-reached' : '') + '">' +
        '<span>' + t.pct + ' %</span>' +
        '<span class="cart-tier__label">' + t.qty + ' art.</span>' +
        '</li>'
      );
    }).join('');

    node.innerHTML =
      '<p class="cart-tier__message">' + message + '</p>' +
      '<div class="cart-tier__track"><div class="cart-tier__fill" style="width:' + fill + '%"></div></div>' +
      '<ol class="cart-tier__steps">' + steps + '</ol>';
    node.hidden = false;
  };

  P.lftRenderDiscount = function (node, cart) {
    var amount = cart.total_discount || 0;
    node.hidden = !(amount > 0) || !(cart.item_count > 0);
    var value = node.querySelector('[data-lft-discount]');
    if (value) value.textContent = amount > 0 ? '-' + this.formatMoney(amount) : '';
  };

  P.lftRenderUpsells = async function (node, cart) {
    var items = cart.items || [];
    if (!items.length) {
      node.hidden = true;
      node.innerHTML = '';
      return;
    }

    // Elke render krijgt een nummer: een trage oude aanvraag mag een nieuwere niet overschrijven
    var token = (this.lftUpsellToken = (this.lftUpsellToken || 0) + 1);
    var self = this;

    // Aanbevelingen voor elk (uniek) product in het mandje, nieuwste eerst
    var productIds = [];
    items.forEach(function (i) {
      if (productIds.indexOf(i.product_id) === -1) productIds.push(i.product_id);
    });
    var inCart = new Set(productIds);
    this.lftUpsellCache = this.lftUpsellCache || {};

    var lists = await Promise.all(productIds.slice(0, 1).map(async function (productId) {
      if (self.lftUpsellCache[productId]) return self.lftUpsellCache[productId];
      try {
        var response = await fetch(
          ROOT + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=related',
          { headers: { Accept: 'application/json' } }
        );
        var data = response.ok ? await response.json() : { products: [] }; data.products = await lftPairs(items[0]);
        self.lftUpsellCache[productId] = data.products || [];
      } catch (error) {
        console.error(error);
        return [];
      }
      return self.lftUpsellCache[productId];
    }));

    if (token !== this.lftUpsellToken) return;

    // Om en om uit elke lijst kiezen, zodat elk product in het mandje aan bod komt
    var picks = [];
    var seen = new Set();
    for (var round = 0; picks.length < MAX_UPSELLS && round < 8; round++) {
      lists.forEach(function (list) {
        var p = list.filter(function (x) {
          return x.available && !inCart.has(x.id) && !seen.has(x.id);
        })[0];
        if (p && picks.length < MAX_UPSELLS) {
          picks.push(p);
          seen.add(p.id);
        }
      });
    }

    if (!picks.length) {
      node.hidden = true;
      node.innerHTML = '';
      return;
    }

    node.innerHTML =
      '<p class="cart-upsell__title">Complétez votre look</p>' +
      '<ul class="cart-upsell__list" role="list">' +
      picks.map(function (p) { return self.lftUpsellCard(p); }).join('') +
      '</ul>';
    node.hidden = false;
  };

  P.lftUpsellCard = function (p) {
    var esc = this.escapeHtml.bind(this);
    var self = this;
    var variants = (p.variants || []).filter(function (v) { return v.available; });

    variants.forEach(function (v) {
      if (self.variantCompareAtPrices && v.compare_at_price) {
        self.variantCompareAtPrices.set(Number(v.id), Number(v.compare_at_price));
      }
    });

    var image = p.featured_image
      ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200'
      : '';
    var compare = p.compare_at_price > p.price ? '<s>' + this.formatMoney(p.compare_at_price) + '</s>' : '';

    // Eén keuzemenu per optie (Couleur, Taille), alleen met waarden die op voorraad zijn
    var options = (p.options || []).map(function (o, index) {
      var name = typeof o === 'string' ? o : o.name;
      var values = [];
      variants.forEach(function (v) {
        var value = (v.options || [v.option1, v.option2, v.option3])[index];
        if (value != null && values.indexOf(value) === -1) values.push(value);
      });
      return { name: name, values: values };
    });

    var lookup = {};
    variants.forEach(function (v) {
      lookup[(v.options || [v.option1, v.option2, v.option3]).slice(0, options.length).join('||')] = v.id;
    });
    this.lftVariantLookup = this.lftVariantLookup || {};
    this.lftVariantLookup[p.id] = lookup;

    var picker;
    if (variants.length === 1) {
      picker = '<input type="hidden" value="' + variants[0].id + '" data-upsell-single>';
    } else {
      picker = options.map(function (o) {
        if (o.values.length === 1) {
          return '<input type="hidden" value="' + esc(o.values[0]) + '" data-upsell-variant>';
        }
        return (
          '<select class="cart-upsell__select" data-upsell-variant aria-label="' + esc(o.name) + '">' +
          '<option value="" selected disabled>' + esc(o.name) + '</option>' +
          o.values.map(function (value) {
            return '<option value="' + esc(value) + '">' + esc(value) + '</option>';
          }).join('') +
          '</select>'
        );
      }).join('');
    }

    return (
      '<li class="cart-upsell__item" data-upsell-product="' + p.id + '">' +
      '<a href="' + esc(p.url) + '" class="cart-upsell__media">' +
      (image ? '<img src="' + esc(image) + '" alt="' + esc(p.title) + '" loading="lazy" width="200" height="250">' : '') +
      '</a>' +
      '<div class="cart-upsell__info">' +
      '<a href="' + esc(p.url) + '" class="cart-upsell__name">' + esc(p.title) + '</a>' +
      '<p class="cart-upsell__price">' + this.formatMoney(p.price) + ' ' + compare + '</p>' +
      '<div class="cart-upsell__actions">' + picker + '</div>' +
      '<button type="button" class="cart-upsell__add" data-upsell-add>Ajouter au panier</button>' +
      '<p class="cart-upsell__error" data-upsell-error hidden></p>' +
      '</div>' +
      '</li>'
    );
  };

  // Producten die via een andere knop of app (bijv. bundels) in het mandje komen: mandje ook bijwerken
  if (window.fetch && !window.lftCartFetchPatched) {
    window.lftCartFetchPatched = true;
    var nativeFetch = window.fetch.bind(window);
    var timer = null;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = nativeFetch(input, init);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var c = window.lftCartDrawer;
            if (!c || c.isRefreshing) return;
            if (c.lftLastRender && Date.now() - c.lftLastRender < 900) return;
            c.refresh();
          }, 400);
        }).catch(function () {});
      }
      return result;
    };
  }

  var origBind = P.bindUI;
  P.bindUI = function () {
    window.lftCartDrawer = this;
    var self = this;
    var result = origBind.apply(this, arguments);
    // Op de mandjespagina (/cart) meteen het uitschuifmandje openen, met kortingsbalk en tips
    if (/\/cart\/?$/.test(location.pathname)) {
      var openNow = function () { self.refresh().then(function () { self.open(); }); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openNow);
      else openNow();
    }
    return result;
  };

  // Oudere telefoons (oudere iPhones) geven geen "submitter" mee: dan alsnog via het mandje toevoegen
  var origAdd = P.handleAddToCart;
  P.handleAddToCart = function (event) {
    var form = event.target;
    if (form instanceof HTMLFormElement && form.matches('[data-product-form]') && !event.submitter) {
      var addButton = form.querySelector('[name="add"]');
      if (addButton) {
        return origAdd.call(this, {
          target: form,
          submitter: addButton,
          preventDefault: function () { event.preventDefault(); }
        });
      }
    }
    return origAdd.call(this, event);
  };

  var origOpen = P.open;
  P.open = function () {
    window.lftCartDrawer = this;
    return origOpen.apply(this, arguments);
  };

  var origRefresh = P.refresh;
  P.refresh = function () {
    window.lftCartDrawer = this;
    return origRefresh.apply(this, arguments);
  };

  P.lftAddUpsell = async function (button) {
    var card = button.closest('.cart-upsell__item');
    if (!card) return;
    var error = card.querySelector('[data-upsell-error]');
    if (error) error.hidden = true;

    var id = 0;
    var single = card.querySelector('[data-upsell-single]');
    if (single) {
      id = Number(single.value);
    } else {
      var fields = Array.prototype.slice.call(card.querySelectorAll('[data-upsell-variant]'));
      var empty = fields.filter(function (f) { return !f.value; });
      if (empty.length) {
        empty.forEach(function (f) { f.classList.add('is-invalid'); });
        empty[0].focus();
        if (error) {
          error.textContent = 'Choisissez d’abord ' + empty.map(function (f) { return f.getAttribute('aria-label').toLowerCase(); }).join(' et ') + '.';
          error.hidden = false;
        }
        return;
      }
      var lookup = (this.lftVariantLookup || {})[card.dataset.upsellProduct] || {};
      id = Number(lookup[fields.map(function (f) { return f.value; }).join('||')] || 0);
      if (!id) {
        if (error) {
          error.textContent = 'Cette combinaison n’est plus disponible. Choisissez une autre option.';
          error.hidden = false;
        }
        return;
      }
    }
    if (!id) return;

    button.disabled = true;
    button.textContent = '…';

    try {
      var response = await fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Upsell toevoegen mislukt');
      await this.refresh();
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.textContent = 'Ajouter au panier';
    }
  };
})();


/* La Famille Tremblay | correct aantal betaalde producten, transparante korting en cadeau-eligibiliteit
   Alleen op dit niet-gepubliceerde testthema. */
(function () {
  if (typeof CartDrawerController === 'undefined') return;
  var P = CartDrawerController.prototype;
  var GIFT_PRODUCT_ID = 15712408142089;
  var GIFT_URL = '/products/large-cashmere-feel-scarf-shawls-solid-colors';
  var TIERS = [{qty:1,pct:10},{qty:2,pct:15},{qty:3,pct:20},{qty:4,pct:25}];

  P.lftPaidQuantity = function (cart) {
    return (cart.items || []).reduce(function (sum, item) {
      var price = Number(item.original_price || item.price || 0);
      var isGift = Number(item.product_id) === GIFT_PRODUCT_ID;
      return sum + (!isGift && price > 0 ? Number(item.quantity || 0) : 0);
    }, 0);
  };

  P.lftRenderTier = function (node, cart) {
    var paid = this.lftPaidQuantity(cart);
    if (!paid) { node.hidden = true; node.innerHTML = ''; return; }
    var step = TIERS.filter(function (t) { return paid >= t.qty; }).pop();
    var next = TIERS.find(function (t) { return paid < t.qty; });
    var extra = next ? next.qty - paid : 0;
    var message = next
      ? '<strong>' + step.pct + ' %</strong> pour ' + paid + ' article' + (paid>1?'s':'') +
        ' payant' + (paid>1?'s':'') + '. Ajoutez ' + extra + ' article' +
        (extra>1?'s':'') + ' payant' + (extra>1?'s':'') + ' pour atteindre <strong>' +
        next.pct + ' %</strong>.'
      : '<strong>Palier de 25 %</strong> atteint avec 4 articles payants ou plus.';
    var steps = TIERS.map(function(t) {
      return '<li class="cart-tier__step'+(paid>=t.qty?' is-reached':'')+'"><span>'+
        t.pct+' %</span><span class="cart-tier__label">'+t.qty+' art.</span></li>';
    }).join('');
    node.innerHTML = '<p class="cart-tier__message">' + message + '</p>' +
      '<div class="cart-tier__track"><div class="cart-tier__fill" style="width:' +
      Math.min(paid/4,1)*100 + '%"></div></div>' +
      '<ol class="cart-tier__steps">' + steps + '</ol>';
    node.hidden = false;
  };

  P.lftRenderDiscount = function(node, cart) {
    var before = Number(cart.original_total_price || 0);
    var total = Number(cart.total_price || 0);
    var amount = Math.max(0, before - total);
    var count = this.lftPaidQuantity(cart);
    var summary = this.drawer.querySelector('.cart-drawer__summary');
    if (!summary) return;
    var original = summary.querySelector('[data-lft-before-discount]');
    if (!original) {
      original = document.createElement('div');
      original.className = 'cart-drawer__summary-row lft-cart-before';
      original.innerHTML = '<span>Sous-total des articles</span><span data-lft-before-amount></span>';
      original.setAttribute('data-lft-before-discount','');
      summary.insertBefore(original, summary.firstChild);
    }
    original.hidden = !count;
    original.querySelector('[data-lft-before-amount]').textContent = this.formatMoney(before);
    node.hidden = !amount;
    var value = node.querySelector('[data-lft-discount]');
    if(value) value.textContent = amount ? '-' + this.formatMoney(amount) : '';
    var label = summary.querySelector('.cart-drawer__subtotal-label');
    if(label) label.textContent = 'Sous-total à payer';
    var compare = summary.querySelector('[data-cart-drawer-compare-subtotal]');
    if(compare) compare.hidden = true;
  };

  P.lftUpdateFreeGift = function(cart) {
    var paid = this.lftPaidQuantity(cart);
    var giftLines = (cart.items || []).filter(function(item) {
      return Number(item.product_id) === GIFT_PRODUCT_ID;
    });
    var offer = this.drawer.querySelector('[data-lft-gift-offer]');
    if (!offer) {
      offer = document.createElement('div');
      offer.className = 'lft-gift-offer';
      offer.setAttribute('data-lft-gift-offer','');
      offer.setAttribute('aria-live','polite');
      var before = this.body.querySelector('.cart-drawer__items');
      if(before) before.before(offer);
      else this.body.prepend(offer);
    }
    var eligible = paid >= 3;
    var existingGift = giftLines.length > 0;
    offer.hidden = !eligible;
    if(eligible) {
      offer.innerHTML = existingGift
        ? '<strong>🎁 Votre foulard gratuit est dans le panier.</strong>'
        : '<strong>🎁 Votre foulard offert est débloqué!</strong>' +
          '<a href="'+GIFT_URL+'">Choisir la couleur de mon foulard</a>';
    }
    if(!eligible && giftLines.length && !this.lftGiftRemoving) {
      this.lftGiftRemoving = true;
      var self=this;
      (async function(){
        try {
          for(var i=0;i<giftLines.length;i++){
            var response=await fetch((window.Shopify?.routes?.root || '/')+'cart/change.js',{
              method:'POST',
              headers:{'Content-Type':'application/json',Accept:'application/json'},
              body:JSON.stringify({id:giftLines[i].key,quantity:0})
            });
            if(!response.ok)throw new Error('Free gift removal failed');
          }
          await self.refresh();
        }catch(e){console.warn('Unable to remove unqualified gift',e);}
        finally {self.lftGiftRemoving = false;}
      })();
      giftLines.forEach(function(item){
        var row=Array.from(self.body.querySelectorAll('[data-cart-item-key]')).find(function(el){
          return el.dataset.cartItemKey===item.key;
        });
        if(row)row.hidden=true;
      });
    }
  };

  var previousExtras = P.lftExtras;
  P.lftExtras = function(cart) {
    previousExtras.call(this,cart);
    this.lftUpdateFreeGift(cart);
  };
})();
